var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
        'button',
        _vm.variant,
        {
            'font-awesome': _vm.fontAwesome,
            full: _vm.full,
            disabled: _vm.disabled,
            loading: _vm.loading
        }
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('div',{class:[{ 'loading-content': _vm.loading }]},[(_vm.fontAwesomeSources[_vm.fontAwesome])?_c('FontAwesomeIcon',{staticClass:"font-awesome",attrs:{"icon":_vm.fontAwesomeSources[_vm.fontAwesome]}}):_vm._e(),_vm._t("default")],2),(_vm.loading)?_c('Spinner',{staticClass:"loading-spinner",attrs:{"size":"small","line-bg-color":"transparent","line-fg-color":_vm.spinnerColors[_vm.variant]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }